import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-821c0c02"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "MvDetail"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NavHeaderVue = _resolveComponent("NavHeaderVue");

  var _component_el_header = _resolveComponent("el-header");

  var _component_VideoMain = _resolveComponent("VideoMain");

  var _component_router_view = _resolveComponent("router-view");

  var _component_el_main = _resolveComponent("el-main");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_container = _resolveComponent("el-container");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_header, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_NavHeaderVue)];
        }),
        _: 1
        /* STABLE */

      }), _createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_scrollbar, {
            height: "600px"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_main, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_router_view, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_Transition, {
                        name: "wzp"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_VideoMain)];
                        }),
                        _: 1
                        /* STABLE */

                      })];
                    }),
                    _: 1
                    /* STABLE */

                  })];
                }),
                _: 1
                /* STABLE */

              })];
            }),
            _: 1
            /* STABLE */

          })];
        }),
        _: 1
        /* STABLE */

      })];
    }),
    _: 1
    /* STABLE */

  })]);
}